/**
 * Session responsive tier from viewport CSS px. Kept minimal on purpose.
 *
 * Laptops often report ~1280×720 (short side under 768) at 100% browser zoom; that is still
 * a wide display — do not force "compact" card layout. The old `shortSide < 768 || longSide < 900`
 * rule treated those as phones and caused huge jumps when zoom changed CSS pixels by ~10%.
 */

export type ResponsiveTier = 'tiny' | 'compact' | 'normal' | 'spacious'

/** Wide landscape viewports: short side can be modest but there is plenty of horizontal room. */
function isWideLandscapeDesktop(shortSide: number, longSide: number): boolean {
  return longSide >= 1200 && longSide / Math.max(shortSide, 1) >= 1.45
}

/** Immediate tier from viewport (no hysteresis — avoids "stuck" states and surprise flips). */
export function computeRawTier(shortSide: number, longSide: number): ResponsiveTier {
  if (shortSide < 480) return 'tiny'

  const shortTight = shortSide < 768
  const bothSmall = longSide < 900 && shortSide < 640

  if (shortTight || bothSmall) {
    if (!isWideLandscapeDesktop(shortSide, longSide)) {
      return 'compact'
    }
  }

  if (shortSide >= 1080) return 'spacious'
  return 'normal'
}

export function tierIsCompact(tier: ResponsiveTier): boolean {
  return tier === 'tiny' || tier === 'compact'
}

export function tierIsTiny(tier: ResponsiveTier): boolean {
  return tier === 'tiny'
}
